module.exports = __webpack_public_path__ + "static/startup5-bf7099af37b735a95adefca1dfe792ac.png";